import { createApi } from '@reduxjs/toolkit/query/react';
import { backend_server_address } from '../../../backendServer';
import { axiosBaseQuery } from '../../../store/utility';

export const modelAPI = createApi({
    reducerPath: 'modelAPI',
    baseQuery: axiosBaseQuery({ baseUrl: `${backend_server_address}/api/model/node/` }),
    endpoints: (builder) => ({
        getNodeSchema: builder.query({
            query: () => ({
                url: 'schema/',
                method: 'GET',
                withCredentials: true,
            }),
        }),
        editNode: builder.mutation({
            query: ({ id, data }) => ({
                url: `${id}/`,
                method: 'PATCH',
                withCredentials: true,
                data,
            }),
        }),
    }),
});

export const { endpoints, useGetNodeSchemaQuery, useEditNodeMutation } = modelAPI;
export const modelAPIReducer = modelAPI.reducer;
export const modelAPIReducerPath = modelAPI.reducerPath;
export const modelAPIReducerMiddleware = modelAPI.middleware;
